import script from "./PopularDestinationItemComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopularDestinationItemComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PopularDestinationItemComponent.vue?vue&type=style&index=0&id=61bcf9b2&lang=css"

const __exports__ = script;

export default __exports__